import type { DriverResponse } from '@contracts/driver/DriverResponse';
import { DriversClient } from '@src/driver/services/DriversClient';
import { useQuery } from '@tanstack/react-query';

export const useDriver = (clientId: string, driverId: string) => {
  const { data: driver = null, isLoading } = useQuery<DriverResponse | null>({
    queryKey: ['drivers.get', clientId, driverId],
    queryFn: () => DriversClient.get(clientId, driverId),
  });
  return {
    driver,
    isLoading,
  };
};
